import { version, description } from '../package.json'

import { createSdkApis } from './interface/sdk-api.interface'
import { createRawApis } from './interface/raw-api.interface'

import InfaceAuth from './inface-auth/inface-auth.class'
import InfaceAuthError from './inface-auth/inface-auth-error.class'
import InfaceLocales from './i18n'
import { InfaceSDK } from '@inface-sdk/common'

const infaceAuth = new InfaceAuth()
const webAuthSdkModule = InfaceSDK.register({
  name: 'web-auth',
  version: version,
  description: description,
  rawApis: createRawApis(infaceAuth),
  sdkApis: [
    { name: 'webAuthModule', action: infaceAuth },
    ...createSdkApis(infaceAuth)],
})

export {
  webAuthSdkModule,
  InfaceAuth,
  InfaceAuthError,
  InfaceLocales
}

export default webAuthSdkModule
